import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { AddQuestionByIDModel } from 'src/app/Models/AddQuestionByID';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddQuestion } from 'src/app/Validators/Validators';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
// import { runInThisContext } from 'vm';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuestionAssignModalComponent } from './question-assign-modal/question-assign-modal.component';
import { NotificationAddEditComponent } from '../../notification-management/notification-add-edit/notification-add-edit.component';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';

@Component({
  selector: 'app-question-add-edit',
  templateUrl: './question-add-edit.component.html',
  styleUrls: ['./question-add-edit.component.css'],
})
export class QuestionAddEditComponent implements OnInit {
  // @Output() Closepopup: EventEmitter<any> = new EventEmitter<any>();
  @Input() subjectById: any;
  @Input() selectedQuestionList: any;
  @Input() selectedQuestionById: any;
  @Input() EditQuestionFlag: boolean;
  @Input() NextButtonflag: boolean;
  @Input() ScreenName1: string;
  @Input() redirect: boolean;
  @Input() questionsubjectresponse: any;
  @Output() ClickQuestionBody: EventEmitter<any> = new EventEmitter<any>();
  @Output() EmitAnswerChoiceDetails: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EmitpreviewDetails: EventEmitter<any> = new EventEmitter<any>();

  @Output() ClickQuestionstatus: EventEmitter<any> = new EventEmitter<any>();
  @Output() ClickQuestionStatusPopup: EventEmitter<any> =
    new EventEmitter<any>();

  @Output() AddQuestionHeaderClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() ClickAnswerChoice: EventEmitter<any> = new EventEmitter<any>();
  @Output() EditAnswerNote: EventEmitter<any> = new EventEmitter<any>();
  @Output() EditSolutionHint: EventEmitter<any> = new EventEmitter<any>();
  @Output() CloseEditQuestion: EventEmitter<any> = new EventEmitter<any>();
  @Output() OpenEditQuestion: EventEmitter<any> = new EventEmitter<any>();
  @Output() ClickQuestionPreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() Refreshlist: EventEmitter<any> = new EventEmitter<any>();

  AddQuestionform: FormGroup;
  AddQuestion: AddQuestionByIDModel;
  QuestionStatus: QuestionStatusModel;
  translationflag: boolean = true;
  Multiquestionflag: boolean = false;
  QuestionBodyflag: boolean = false;
  AnswerSelectiontype: any;
  defaultlanguage: any;
  getquestionprimaryusagetype: any;
  primaryUsageType: any;
  Answertype: any;
  getdifficultleveltype: any;
  questiongktype: any;
  questionscopetype: any;
  safehtmlStr: SafeHtml;
  InsertAnswerChoice: AnswerChoiceModel;
  tempvariable: boolean = false;
  Buttonflg: string;
  //  public QuestionByIDlist:any;
  //  public QuestionBodylist:any;
  //  public AnswerChoicelist:any;
  //  public AnswerChoiceNotelist:any;
  //  public Previewlist:any;
  constructor(
    private router: Router,
    public dom: DomSanitizer,
    public service: QuestionManagementService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private modalService: NgbModal,
     private modalServiceLocal: ModalService,

  ) {}
  InitializeForm() {
    this.AddQuestionform = this.fb.group({
      Language_Type_Code: ['', VAddQuestion],
      Question_Primary_Usage_Type_Code: ['', VAddQuestion],
      Answer_Type_Code: ['', VAddQuestion],
      //Answer_Type_Name:["",VAddQuestion],
      Answer_Selection_Type_Code: ['', VAddQuestion],
      Recommended_Response_Time_Type_Code: ['', VAddQuestion],
      Question_Status_Type_Code: [{ value: '', disabled: true }, VAddQuestion],
      Question_Gk_Type_Code: ['', VAddQuestion],
      Location_ID: ['', VAddQuestion],
      Competative_Exam_Grade_Question_Ind:[true],
      RelevantRegion: [],
      Comment_Text: [],
      Question_ID: [{ value: '', disabled: true }],
      Question_Text: [],
    });
  }
  QuestionNo: any;
  SubjectID: any;
  arrayIndex: number;
  testiframe: string;
  ngOnInit() {
    this.InitializeForm();

    this.getBreadcrumbDetails();
    this.getLanguage();
    this.getQuestionPrimaryUsageType();
    this.getAnswerSelectionType();
    this.getAnswerType();
    this.getDifficultLevelType();
    this.getRegionType();
    this.getQuestionGKType();
    this.getQuestionScopeType();
    this.getQuestionStatusType();
    this.getResponseTimeType();
    if (
      this.selectedQuestionById != null &&
      this.selectedQuestionById != undefined
    ) {
      if (this.selectedQuestionById.length >= 0) {
        this.QuestionNo = this.selectedQuestionById[0].Question_ID;
        this.SubjectID = this.subjectById.Subject_Id;
        //previous and next button filter
        // if (!this.NextButtonflag) {
        //   for (let i = 0; i < this.questionsubjectresponse.length; i++) {
        //     if (
        //       this.questionsubjectresponse[i].Question_Id == this.QuestionNo
        //     ) {
        //       this.arrayIndex = i;
        //       this.Validation(this.questionsubjectresponse, i);
        //     }
        //   }
        // }
      }
    }
    if (this.QuestionNo && this.SubjectID) {
      this.getQuestionUsage({
        QuestionID: this.QuestionNo,
        SubjectID: this.SubjectID,
      });
    }

    if (
      this.selectedQuestionById != null &&
      this.selectedQuestionById != undefined
    ) {
      if (this.selectedQuestionById.length >= 0) {
        if (this.selectedQuestionById[0].Question_ID != null) {
          this.getQuestionByID(this.selectedQuestionById[0].Question_ID);
          if (
            this.selectedQuestionById[0].Question_Text != null &&
            this.selectedQuestionById[0].Question_Text != ''
          ) {
            this.safehtmlStr = this.dom.bypassSecurityTrustHtml(
              this.selectedQuestionById[0].Question_Text
            );
            this.testiframe = this.selectedQuestionById[0].Question_Text;
          }
          this.GetAnswerChoiceByQuestionID(
            this.selectedQuestionById[0].Question_ID
          );
        } else {
          this.getQuestionByID(null);
        }
      } else {
        if (this.selectedQuestionById.Question_ID != null) {
          this.getQuestionByID(this.selectedQuestionById.Question_ID);
          if (
            this.selectedQuestionById != null &&
            this.selectedQuestionById != undefined
          ) {
            if (this.selectedQuestionById.length >= 0) {
              if (
                this.selectedQuestionById[0].Question_Text != null &&
                this.selectedQuestionById[0].Question_Text != ''
              ) {
                this.safehtmlStr = this.dom.bypassSecurityTrustHtml(
                  this.selectedQuestionById[0].Question_Text
                );
                this.testiframe = this.selectedQuestionById[0].Question_Text;
              }
            }
          }
          this.GetAnswerChoiceByQuestionID(
            this.selectedQuestionById.Question_ID
          );
        } else {
          this.getQuestionByID(null);
        }
      }
    } else {
      this.getQuestionByID(null);
    }
  }

  ngAfterViewInit() {}

  AssignCourses() {
    const modalRef = this.modalService.open(QuestionAssignModalComponent, {
      backdrop: 'static',
      keyboard: false,
      scrollable: true,
      windowClass: 'custom-modal-width',
      backdropClass: 'light-blue-backdrop',
    });
    modalRef.componentInstance.SubjectId = null;
    modalRef.componentInstance.isEdit = true;
    modalRef.componentInstance.QuestionId =
      this.selectedQuestionById[0].Question_ID || null;
    modalRef.componentInstance.ScreenName = 'ASSIGN_QUESTION_TO_COURSE';
  }

  getQuestionUsagelist: any;
  response: any;
  getQuestionUsage(data: any) {
    this.service.GetQuestionUsageSetting(data).subscribe(
      (i: any) => {
        this.response = i;
        this.getQuestionUsagelist = this.response.data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getlanguage: any;

  getLanguage() {
    this.service.GetCode({ Tablename: 'LANGUAGE_TYPE' }).subscribe(
      (i: any) => {
        this.getlanguage = i;
        if (
          this.selectedQuestionById == null &&
          this.selectedQuestionById == undefined
        ) {
          // if(this.selectedQuestionById.length<=0){
          // if(this.selectedQuestionById[0].Question_ID==null){
          this.defaultlanguage = this.getlanguage[1].Code;
        }
        // }}}

        // }).catch((e:any)=>{
        //   this.getlanguage=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getQuestionPrimaryUsageType() {
    this.service
      .GetCode({ Tablename: 'QUESTION_PRIMARY_USAGE_TYPE' })
      .subscribe(
        (i: any) => {
          this.getquestionprimaryusagetype = i;
          if (
            this.selectedQuestionById == null &&
            this.selectedQuestionById == undefined
          ) {
            if (
              this.getquestionprimaryusagetype &&
              this.getquestionprimaryusagetype.length > 0
            ) {
              this.primaryUsageType = this.getquestionprimaryusagetype[0].Code;
              this.AddQuestionform.controls[
                'Question_Primary_Usage_Type_Code'
              ].setValue(this.getquestionprimaryusagetype[0].Code);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getAnswerSelectiontype: any;

  getAnswerSelectionType() {
    this.service.GetCode({ Tablename: 'ANSWER_SELECTION_TYPE' }).subscribe(
      (i: any) => {
        this.getAnswerSelectiontype = i;
        if (
          this.selectedQuestionById == null &&
          this.selectedQuestionById == undefined
        ) {
          this.AnswerSelectiontype = this.getAnswerSelectiontype[0].Code;
        }
        // }).catch((e:any)=>{
        //   this.getAnswerSelectiontype=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAnswertype: any;

  getAnswerType() {
    this.service.GetCode({ Tablename: 'ANSWER_TYPE' }).subscribe(
      (i: any) => {
        this.getAnswertype = i;
        if (
          this.selectedQuestionById == null &&
          this.selectedQuestionById == undefined
        ) {
          this.Answertype = this.getAnswertype[0].Code;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDifficultLevelType() {
    this.service.GetCode({ Tablename: 'DIFFICULTY_LEVEL_TYPE' }).subscribe(
      (i: any) => {
        this.getdifficultleveltype = i;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getregiontype: any;
  getRegionType() {
    this.service.GetCode({ Tablename: 'REGION_TYPE' }).subscribe(
      (i: any) => {
        this.getregiontype = i;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getquestiongktype: any;

  getQuestionGKType() {
    this.service.GetCode({ Tablename: 'QUESTION_GK_TYPE' }).subscribe(
      (i: any) => {
        this.getquestiongktype = i;
        if (
          this.selectedQuestionById == null &&
          this.selectedQuestionById == undefined
        ) {
          this.questiongktype = this.getquestiongktype[3].Code;
          this.AddQuestionform.controls['Question_Gk_Type_Code'].setValue(
            this.getquestiongktype[3].Code
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getquestionscopetype: any;

  getQuestionScopeType() {
    this.service.GetCode({ Tablename: 'QUESTION_SCOPE_TYPE' }).subscribe(
      (i: any) => {
        this.getquestionscopetype = i;
        if (
          this.selectedQuestionById == null &&
          this.selectedQuestionById == undefined
        ) {
          this.questionscopetype = this.getquestionscopetype[2].Code;
        }
        // }).catch((e:any)=>{
        //   this.getquestiongktype=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getquestionstatustype: any;
  questionstatustype: any;
  getQuestionStatusType() {
    this.service.GetCode({ Tablename: 'QUESTION_STATUS_TYPE' }).subscribe(
      (i: any) => {
        this.getquestionstatustype = i;

        if (
          this.selectedQuestionById == null &&
          this.selectedQuestionById == undefined
        ) {
          this.questionstatustype = this.getquestionstatustype[0].Code;
          this.AddQuestionform.controls['Question_Status_Type_Code'].setValue(
            this.getquestionstatustype[0].Code
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getresponsetimetype: any;
  getResponseTimeType() {
    this.service.GetCode({ Tablename: 'RESPONSE_TIME_TYPE' }).subscribe(
      (i: any) => {
        this.getresponsetimetype = i;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  get questionStatusTypeCode() {
    return this.AddQuestionform.getRawValue().Question_Status_Type_Code;
  }

  get questionGkTypeCode() {
    return this.AddQuestionform.getRawValue().Question_Gk_Type_Code;
  }

  getQuestionByIDlist: any;
  Questionlist: any;
  Questionid: string;
  Questionstatustypecode: any;

  getQuestionByID(data: any) {
    this.service.GetQuestionByID({ QuestionID: data }).subscribe(
      (i: any) => {
        this.Questionlist = i;
        this.getQuestionByIDlist = this.Questionlist.result;
        this.service.QuestionByIDlist = this.getQuestionByIDlist;
        this.tempvariable = false;
        if (
          this.getQuestionByIDlist != null &&
          this.getQuestionByIDlist != undefined
        ) {
          if (this.getQuestionByIDlist.length > 0) {
            if (this.getQuestionByIDlist[0].Question_ID != null) {

              this.AddQuestionform.controls[
                'Answer_Selection_Type_Code'
              ].setValue(
                this.getQuestionByIDlist[0].Answer_Selection_Type_Code
              );
              this.AddQuestionform.controls['Competative_Exam_Grade_Question_Ind'].setValue(
                this.getQuestionByIDlist[0].Competative_Exam_Grade_Question_Ind ?
                this.getQuestionByIDlist[0].Competative_Exam_Grade_Question_Ind ==='Y' ?true:false :true
              );
              this.AddQuestionform.controls['Answer_Type_Code'].setValue(
                this.getQuestionByIDlist[0].Answer_Type_Code
              );
              this.AddQuestionform.controls['Question_Gk_Type_Code'].setValue(
                this.getQuestionByIDlist[0].Question_Gk_Type_Code
              );
              this.AddQuestionform.controls['Question_ID'].setValue(
                this.getQuestionByIDlist[0].Question_ID
              );
              if (this.getQuestionByIDlist[0].Question_ID != null) {
                this.QuestionBodyflag = true;
              }
              if (this.getQuestionByIDlist[0].Comment_Text != null) {
                this.AddQuestionform.controls['Comment_Text'].setValue(
                  this.getQuestionByIDlist[0].Comment_Text
                );
              }
              this.AddQuestionform.controls['Language_Type_Code'].setValue(
                this.getQuestionByIDlist[0].Language_Type_Code
              );
              this.AddQuestionform.controls[
                'Question_Primary_Usage_Type_Code'
              ].setValue(
                this.getQuestionByIDlist[0].Question_Primary_Usage_Type_Code
              );
              this.primaryUsageType =
                this.getQuestionByIDlist[0].Question_Primary_Usage_Type_Code;
              this.AddQuestionform.controls[
                'Recommended_Response_Time_Type_Code'
              ].setValue(
                this.getQuestionByIDlist[0].Recommended_Response_Time_Type_Code
              );
              this.AddQuestionform.controls[
                'Question_Status_Type_Code'
              ].setValue(this.getQuestionByIDlist[0].Question_Status_Type_Code);
              this.AddQuestionform.controls['Location_ID'].setValue(
                this.getQuestionByIDlist[0].Location_ID
              );
              this.Questionstatustypecode =
                this.getQuestionByIDlist[0].Question_Status_Type_Code;

              if (this.getQuestionByIDlist[0].Multi_Part_Question_Ind == 'Y') {
                this.Multiquestionflag = true;
              } else {
                this.Multiquestionflag = false;
              }
              if (this.getQuestionByIDlist[0].Allow_Translation_Ind == 'Y') {
                this.translationflag = true;
              } else {
                this.translationflag = false;
              }

              if (
                this.getQuestionByIDlist[0].Question_Text != null &&
                this.getQuestionByIDlist[0].Question_Text != ''
              ) {
                this.safehtmlStr = this.dom.bypassSecurityTrustHtml(
                  this.getQuestionByIDlist[0].Question_Text
                );
              }
              const status =
                this.AddQuestionform.getRawValue().Question_Status_Type_Code;

              // Enable or disable based on status
              if (status !== 'WIP' && status !== 'Rework') {
                this.AddQuestionform.controls['Question_Gk_Type_Code'].disable({
                  emitEvent: false,
                });
              } else {
                this.AddQuestionform.controls['Question_Gk_Type_Code'].enable({
                  emitEvent: false,
                });
              }
              //this.GetAnswerChoiceByQuestionID(this.getQuestionByIDlist[0].Question_ID);
              // }).catch((e:any)=>{
              //   this.getQuestionByIDlist=null;
              // });
              // if(this.redirect){

              //   this.Answerchoicepopup('R');

              //   }

              if (!this.EditQuestionFlag) {
                this.OpenEditQuestion.emit(this.getQuestionByIDlist[0]);
              }

              if (this.redirect) {
                if (
                  this.Answerchoiceflag &&
                  this.getQuestionByIDlist[0].Question_Text
                ) {
                  this.Answerchoicepopup('R');
                }
              }
            }
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  AnswerChoiceByQuestionid: any;
  AnswerChoice: any;
  Answerchoiceflag: boolean = false;
  GetAnswerChoiceByQuestionID(data: any) {
    this.service.GetAnswerChoiceByQuestionID({ QuestionID: data }).subscribe(
      (i: any) => {
        this.AnswerChoice = i;
        this.AnswerChoiceByQuestionid = this.AnswerChoice.SubjectExistsInd;
        this.Answerchoiceflag = true;

        this.AnswerChoiceByQuestionid.map(
          (obj: {
            SolutionHint_Answer_Choice_Note_Body_Id: null;
            SolutionHint_Answer_Choice_Id: null;
            Answer_SolutionHintflag: boolean;
            SolutionIndflag: boolean;
            AnswerNoteflag: boolean;
            Answer_Choice_Id: null;
            Answer_Choice_Note_Body_Id: null;
          }) => {
            obj.AnswerNoteflag = false;
            obj.Answer_Choice_Id = null;
            obj.Answer_Choice_Note_Body_Id = null;
            obj.Answer_SolutionHintflag = false;
            obj.SolutionHint_Answer_Choice_Id = null;
            obj.SolutionHint_Answer_Choice_Note_Body_Id = null;
            return obj;
          }
        );
        this.AnswerChoiceInitialize(this.AnswerChoiceByQuestionid);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  AnswerChoiceNoteList1: any;
  AnswerChoicenote: any;
  GetAnswerChoiceNoteByID(data: any, value: string) {
    this.service.GetAnserChoiceNoteByID({ AnswerChoiceID: data }).subscribe(
      (i: any) => {
        let data: any = i;
        this.AnswerChoicenote = i;
        this.AnswerChoiceNoteList1 = this.AnswerChoicenote.AnswerChoiceNoteList;
        if (
          this.AnswerChoiceNoteList1 &&
          this.AnswerChoiceNoteList1.length > 0
        ) {
          this.AnswerChoiceNoteList1.forEach(
            (
              currentValue: {
                Answer_Choice_Note_Body_Id: any;
                Answer_Choice_Id: any;
                Answer_Choice_Note_Body_Text: string;
                Hint_Ind: any;
              },
              _index: any
            ) => {
              if (currentValue != null) {
                if (value == 'R') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.RightAnswer1.AnswerNoteflag = true;
                    this.RightAnswer1.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.RightAnswer1.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.RightAnswer1.Answer_SolutionHintflag = true;
                    this.RightAnswer1.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.RightAnswer1.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                } else if (value == 'W1') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer1.AnswerNoteflag = true;
                    this.WrongAnswer1.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer1.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer1.Answer_SolutionHintflag = true;
                    this.WrongAnswer1.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer1.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }

                  // this.WrongAnswer1.AnswerNoteflag=true;

                  // this.WrongAnswer1.Answer_Choice_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Id;
                  // this.WrongAnswer1.Answer_Choice_Note_Body_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Note_Body_Id;
                } else if (value == 'W2') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer2.AnswerNoteflag = true;
                    this.WrongAnswer2.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer2.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer2.Answer_SolutionHintflag = true;
                    this.WrongAnswer2.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer2.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                  // this.WrongAnswer2.AnswerNoteflag=true;

                  // this.WrongAnswer2.Answer_Choice_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Id;
                  // this.WrongAnswer2.Answer_Choice_Note_Body_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Note_Body_Id;
                } else if (value == 'W3') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer3.AnswerNoteflag = true;
                    this.WrongAnswer3.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer3.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer3.Answer_SolutionHintflag = true;
                    this.WrongAnswer3.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer3.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                  // this.WrongAnswer3.AnswerNoteflag=true;

                  // this.WrongAnswer3.Answer_Choice_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Id;
                  // this.WrongAnswer3.Answer_Choice_Note_Body_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Note_Body_Id;
                } else if (value == 'W4') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer4.AnswerNoteflag = true;
                    this.WrongAnswer4.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer4.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer4.Answer_SolutionHintflag = true;
                    this.WrongAnswer4.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer4.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                  // this.WrongAnswer4.AnswerNoteflag=true;

                  // this.WrongAnswer4.Answer_Choice_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Id;
                  // this.WrongAnswer4.Answer_Choice_Note_Body_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Note_Body_Id;
                } else if (value == 'W5') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer5.AnswerNoteflag = true;
                    this.WrongAnswer5.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer5.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer5.Answer_SolutionHintflag = true;
                    this.WrongAnswer5.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer5.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                  // this.WrongAnswer5.AnswerNoteflag=true;

                  // this.WrongAnswer5.Answer_Choice_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Id;
                  // this.WrongAnswer5.Answer_Choice_Note_Body_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Note_Body_Id;
                } else if (value == 'W6') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer6.AnswerNoteflag = true;
                    this.WrongAnswer6.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer6.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer6.Answer_SolutionHintflag = true;
                    this.WrongAnswer6.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer6.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }
                  // this.WrongAnswer6.AnswerNoteflag=true;

                  // this.WrongAnswer6.Answer_Choice_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Id;
                  // this.WrongAnswer6.Answer_Choice_Note_Body_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Note_Body_Id;
                } else if (value == 'W7') {
                  if (currentValue.Hint_Ind == 'N') {
                    this.WrongAnswer7.AnswerNoteflag = true;
                    this.WrongAnswer7.Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer7.Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  } else {
                    this.WrongAnswer7.Answer_SolutionHintflag = true;
                    this.WrongAnswer7.SolutionHint_Answer_Choice_Id =
                      currentValue.Answer_Choice_Id;
                    this.WrongAnswer7.SolutionHint_Answer_Choice_Note_Body_Id =
                      currentValue.Answer_Choice_Note_Body_Id;
                  }

                  // this.WrongAnswer7.AnswerNoteflag=true;

                  // this.WrongAnswer7.Answer_Choice_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Id;
                  // this.WrongAnswer7.Answer_Choice_Note_Body_Id=this.AnswerChoiceNoteList1[0].Answer_Choice_Note_Body_Id;
                }
              }
            }
          );
        }

        // if(this.AnswerChoiceList!=null){
        // this.AddAnswerChoiceform.controls['Answer_Choice_Body_Text'].setValue(this.AnswerChoiceList[0].Answer_Choice_Body_Text);
        // }
        // else{
        //   this.AddAnswerChoiceform.controls['Answer_Choice_Body_Text'].setValue(this.AnswerChoiceList[0].Answer_Choice_Body_Text);
        // }

        // this.selectedQuestionList.map((obj) => {
        // obj.checkedflag = false;
        // return obj;
        // })
        // }).catch((e:any)=>{
        //   this.AnswerChoiceNoteList1=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  RightAnswer1: any;
  WrongAnswer1: any;
  WrongAnswer2: any;
  WrongAnswer3: any;
  WrongAnswer4: any;
  WrongAnswer5: any;
  WrongAnswer6: any;
  WrongAnswer7: any;
  RightAnswer11: SafeHtml;
  WrongAnswer11: SafeHtml;
  WrongAnswer22: SafeHtml;
  WrongAnswer33: SafeHtml;
  WrongAnswer44: SafeHtml;
  WrongAnswer55: SafeHtml;
  WrongAnswer66: SafeHtml;
  WrongAnswer77: SafeHtml;

  answer_choice_id: number;
  AnswerChoiceInitialize(answerchoices: any) {
    for (let item of answerchoices) {
      if (item.Right_Answer_Ind == 'Y') {
        this.answer_choice_id = item.Answer_Choice_ID;
        this.RightAnswer1 = item;
        this.service.AnswerChoicelist = this.RightAnswer1;
        this.RightAnswer11 = this.dom.bypassSecurityTrustHtml(
          this.RightAnswer1.Answer_Choice_Text
        );

        if (item.Answer_Choice_ID != null) {
          this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'R');
        }
      }
      if (item.Right_Answer_Ind == 'N') {
        if (
          this.answer_choice_id == null ||
          this.answer_choice_id == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
        }
        if (this.WrongAnswer1 == null || this.WrongAnswer1 == undefined) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer1 = item;
          this.WrongAnswer11 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer1.Answer_Choice_Text
          );

          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W1');
          }
        } else if (
          this.WrongAnswer2 == null ||
          this.WrongAnswer2 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer2 = item;
          this.WrongAnswer22 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer2.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W2');
          }
        } else if (
          this.WrongAnswer3 == null ||
          this.WrongAnswer3 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer3 = item;
          this.WrongAnswer33 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer3.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W3');
          }
        } else if (
          this.WrongAnswer4 == null ||
          this.WrongAnswer4 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer4 = item;
          this.WrongAnswer44 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer4.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W4');
          }
        } else if (
          this.WrongAnswer5 == null ||
          this.WrongAnswer5 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer5 = item;
          this.WrongAnswer55 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer5.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W5');
          }
        } else if (
          this.WrongAnswer6 == null ||
          this.WrongAnswer6 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer6 = item;
          this.WrongAnswer66 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer6.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W6');
          }
        } else if (
          this.WrongAnswer7 == null ||
          this.WrongAnswer7 == undefined
        ) {
          this.answer_choice_id = item.Answer_Choice_ID;
          this.WrongAnswer7 = item;
          this.WrongAnswer77 = this.dom.bypassSecurityTrustHtml(
            this.WrongAnswer7.Answer_Choice_Text
          );
          if (item.Answer_Choice_ID != null) {
            this.GetAnswerChoiceNoteByID(item.Answer_Choice_ID, 'W7');
          }
        } else {
        }
      }
      // else{
      //   this.RightAnswer1=null;
      //   this.WrongAnswer1=null;
      //   this.WrongAnswer2=null;
      //   this.WrongAnswer3=null;
      //   this.WrongAnswer4=null;
      //   this.WrongAnswer5=null;
      //   this.WrongAnswer6=null;
      //   this.WrongAnswer7=null;

      // }
    }
    if (this.redirect) {
      if (this.Answerchoiceflag && this.getQuestionByIDlist[0].Question_ID) {
        this.Answerchoicepopup('R');
      }
    }
  }

  EditAnswerNotepopup(data: any, Indicator: any) {
    if (Indicator == 'N') {
      this.EditAnswerNote.emit(data);
    } else if (Indicator == 'Y') {
      this.EditSolutionHint.emit(data);
    }
  }

  save_submitted: boolean = false;
  AddQuestionResponse: any;
  Modalclose: boolean;
  AddQuestionHeader() {
    if (this.AddQuestionform.valid) {
      this.AddQuestion = this.AddQuestionform.getRawValue();
      this.AddQuestion.SubjectId = this.subjectById.Subject_Id;
      this.AddQuestion.SubjectShortCode = this.subjectById.Subject_Short_Code;
      this.AddQuestion.LanguageInd = this.subjectById.Language_Ind;
      this.AddQuestion.Question_Text = '';
      const isChecked = this.AddQuestionform.getRawValue().Competative_Exam_Grade_Question_Ind;

      this.AddQuestion.CompetativeExamGradeQuestionInd  = isChecked ? 'Y' : 'N';
      delete this.AddQuestion.Competative_Exam_Grade_Question_Ind;

      this.AddQuestion.QuestionPrimaryUsageTypeCode =
        this.AddQuestionform.getRawValue().Question_Primary_Usage_Type_Code;
      delete this.AddQuestion.Question_Primary_Usage_Type_Code;

      // if(this.getQuestionByIDlist[0].Question_Search_Text!=null){
      // this.AddQuestion.Question_Search_Text=this.getQuestionByIDlist[0].Question_Search_Text;
      // }
      // else{
      //   this.AddQuestion.Question_Search_Text='';
      // }

      for (let item of this.selectedQuestionList) {
        if (item.checkedflag) {
          this.AddQuestion.Question_Template_ID = item.Question_Template_ID;
        }
      }
      if (this.Multiquestionflag) {
        this.AddQuestion.Multi_Part_Question_Ind = 'Y';
      } else {
        this.AddQuestion.Multi_Part_Question_Ind = 'N';
      }
      if (this.translationflag) {
        this.AddQuestion.Allow_Translation_Ind = 'Y';
      } else {
        this.AddQuestion.Allow_Translation_Ind = 'N';
      }
      if (this.safehtmlStr != null) {
        this.AddQuestion.Question_Text =
          this.getQuestionByIDlist[0].Question_Text;
        this.AddQuestion.Question_Search_Text =
          this.getQuestionByIDlist[0].Question_Search_Text;
      } else {
        this.AddQuestion.Question_Text = '';
        this.AddQuestion.Question_Search_Text = '';
      }
      this.service.CreateOrModifyQuestion(this.AddQuestion).subscribe(
        (i: any) => {
          this.AddQuestionResponse = i;
          if (this.AddQuestionResponse.Message == 'Success') {
            this.toastr.success('Saved Successfully', 'Success',{timeOut: 500});
            this.CreateNotification()
            this.save_submitted = false;
            if (
              this.AddQuestionResponse.Value != null &&
              this.AddQuestionResponse.Value != ''
            ) {
              this.getQuestionByID(this.AddQuestionResponse.Value);
            } else {
              this.getQuestionByID(
                this.AddQuestionform.getRawValue().Question_ID
              );
            }

            // if (this.EditQuestionFlag) {
            //   this.CloseEditQuestion.emit(this.Modalclose);
            // }
            //   else{
            //     if(this.AddQuestionResponse.Value!=null&&this.AddQuestionResponse.Value!=""){
            //       this.OpenEditQuestion.emit(this.AddQuestionResponse.Value);
            //     }
            //     else{
            //       this.OpenEditQuestion.emit(this.AddQuestionform.controls['Question_ID'].value);
            //     }
            //  }
          } else {
            this.toastr.error(this.AddQuestionResponse.Message);
          }
          //  }).catch((e:any)=>{
          //    this.AddQuestionResponse=e;
          //    this.toastr.error(this.AddQuestionResponse.statusText);
          //    this.save_submitted=false;

          //  }
          //  )
        },
        (error) => {
          this.AddQuestionResponse = error;
          this.toastr.error(this.AddQuestionResponse.Message);
          this.save_submitted = false;
          console.log(error);
        }
      );
    }
  }

  async CreateNotification(): Promise<boolean> {
    try {
      // Step 1: Ask for confirmation
      const result = await this.modalServiceLocal.open(
        'Confirmation',
        'Do you want to send notification to all the users about this Question?',
        'Yes',
        'No'
      );

      if (!result) {
        return false; // user cancelled
      }

      // Step 2: Open notification modal
      const modalRef = this.modalService.open(NotificationAddEditComponent, {
        centered: true,
        size: 'xl',
        windowClass: 'custom-modal-width-notification-question',
        backdropClass: 'custom-backdrop-notification'
      });

      // Pass data into modal
      modalRef.componentInstance.screenName = 'Question';
      modalRef.componentInstance.MaterialId =this.AddQuestionform.getRawValue().Question_ID

      // Step 3: Wait for modal close result
      const notificationResult = await modalRef.result
        .then((res: any) => res)
        .catch(() => false);

      return !!notificationResult;
    } catch (error) {
      console.error('CreateNotification dismissed or failed:', error);
      return false;
    }
  }
  CloseEdit(_data: any) {
    if (this.EditQuestionFlag) {
      this.CloseEditQuestion.emit(this.relocatepopupflag);
    }
  }

  Allowtranslation() {
    this.translationflag = !this.translationflag;
    this.Editformvalidation();
    // if(this.translationflag){
    //    this.AddQuestion.Allow_Translation_Ind='Y';
    // }
    // else{
    //   this.AddQuestion.Allow_Translation_Ind='N';
    // }
  }

  Multiquestion() {
    this.Multiquestionflag = !this.Multiquestionflag;
    this.Editformvalidation();
    // if(this.Multiquestionflag){
    //   this.AddQuestion.Multi_Part_Question_Ind='Y';
    // }
    // else{
    //  this.AddQuestion.Multi_Part_Question_Ind='N';
    // }
  }
  // QuestionBodyModalPopup:boolean
  QuestionBodypopup() {
    this.service.ScreenTrackName = 'app-question-add-edit';
    this.ClickQuestionBody.emit(this.getQuestionByIDlist);
    this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    // if(this.RightAnswer1&&this.RightAnswer1!=undefined){
    // this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    // }
    // else if(this.WrongAnswer1&&this.WrongAnswer1!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.WrongAnswer1);
    // }
    // else if(this.WrongAnswer2&&this.WrongAnswer2!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.WrongAnswer2);
    // }
    // else if(this.WrongAnswer3&&this.WrongAnswer3!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.WrongAnswer3);
    // }
    // else if(this.WrongAnswer4&&this.WrongAnswer4!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.WrongAnswer4);
    // }
    // else if(this.WrongAnswer5&&this.WrongAnswer5!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.WrongAnswer5);
    // }
    // else if(this.WrongAnswer6&&this.WrongAnswer6!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.WrongAnswer6);
    // }
    // else if(this.WrongAnswer7&&this.WrongAnswer7!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.WrongAnswer7);
    // }
    // else{
    //   this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    // }

    let list = {
      safehtmlStr: this.safehtmlStr,
      RightAnswer11: this.RightAnswer11,
      WrongAnswer11: this.WrongAnswer11,
      WrongAnswer22: this.WrongAnswer22,
      WrongAnswer33: this.WrongAnswer33,
      WrongAnswer44: this.WrongAnswer44,
      WrongAnswer55: this.WrongAnswer55,
      WrongAnswer66: this.WrongAnswer66,
      WrongAnswer77: this.WrongAnswer77,
      RightAnswer1: this.RightAnswer1,
      WrongAnswer1: this.WrongAnswer1,
      WrongAnswer2: this.WrongAnswer2,
      WrongAnswer3: this.WrongAnswer3,
      WrongAnswer4: this.WrongAnswer4,
      WrongAnswer5: this.WrongAnswer5,
      WrongAnswer6: this.WrongAnswer6,
      WrongAnswer7: this.WrongAnswer7,
    };
    this.EmitpreviewDetails.emit(list);
  }

  AnswerchoiceModalPopup: boolean;
  SelectedAnswer: any;

  Answerchoicepopup(data: any) {
    this.service.ScreenTrackName = 'app-question-add-edit';
    this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    // if(this.RightAnswer1&&this.RightAnswer1!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    //   }
    //   else if(this.WrongAnswer1&&this.WrongAnswer1!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer1);
    //   }
    //   else if(this.WrongAnswer2&&this.WrongAnswer2!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer2);
    //   }
    //   else if(this.WrongAnswer3&&this.WrongAnswer3!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer3);
    //   }
    //   else if(this.WrongAnswer4&&this.WrongAnswer4!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer4);
    //   }
    //   else if(this.WrongAnswer5&&this.WrongAnswer5!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer5);
    //   }
    //   else if(this.WrongAnswer6&&this.WrongAnswer6!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer6);
    //   }
    //   else if(this.WrongAnswer7&&this.WrongAnswer7!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer7);
    //   }
    //   else{
    //     this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    //   }
    let list = {
      Answer_Choice_ID: null,
      Question_ID: this.getQuestionByIDlist[0].Question_ID,
      Question_Status_ID: this.getQuestionByIDlist[0].Question_Status_ID,
    };
    if (data == 'R') {
      if (this.RightAnswer1 != null) {
        this.SelectedAnswer = this.RightAnswer1;
        data = 'R';
      } else {
        this.SelectedAnswer = list;
      }
    } else if (data == 'W1') {
      if (this.WrongAnswer1 != null) {
        this.SelectedAnswer = this.WrongAnswer1;
        data = 'W';
      } else {
        this.SelectedAnswer = list;
      }
    } else if (data == 'W2') {
      if (this.WrongAnswer2 != null) {
        this.SelectedAnswer = this.WrongAnswer2;
        data = 'W';
      } else {
        this.SelectedAnswer = list;
      }
    } else if (data == 'W3') {
      if (this.WrongAnswer3 != null) {
        this.SelectedAnswer = this.WrongAnswer3;
        data = 'W';
      } else {
        this.SelectedAnswer = list;
      }
    } else if (data == 'W4') {
      if (this.WrongAnswer4 != null) {
        this.SelectedAnswer = this.WrongAnswer4;
        data = 'W';
      } else {
        this.SelectedAnswer = list;
      }
    } else if (data == 'W5') {
      if (this.WrongAnswer5 != null) {
        this.SelectedAnswer = this.WrongAnswer5;
        data = 'W';
      } else {
        this.SelectedAnswer = list;
      }
    } else if (data == 'W6') {
      if (this.WrongAnswer6 != null) {
        this.SelectedAnswer = this.WrongAnswer6;
        data = 'W';
      } else {
        this.SelectedAnswer = list;
      }
    } else if (data == 'W7') {
      if (this.WrongAnswer7 != null) {
        this.SelectedAnswer = this.WrongAnswer7;
        data = 'W';
      } else {
        this.SelectedAnswer = list;
      }
    } else {
      if (this.WrongAnswer1 != null) {
        this.SelectedAnswer = this.WrongAnswer1;
      } else {
        this.SelectedAnswer = list;
      }
    }

    this.ClickAnswerChoice.emit({
      QuestionById: this.SelectedAnswer,
      Answerflag1: data,
    });
    let list1 = {
      safehtmlStr: this.safehtmlStr,
      RightAnswer11: this.RightAnswer11,
      WrongAnswer11: this.WrongAnswer11,
      WrongAnswer22: this.WrongAnswer22,
      WrongAnswer33: this.WrongAnswer33,
      WrongAnswer44: this.WrongAnswer44,
      WrongAnswer55: this.WrongAnswer55,
      WrongAnswer66: this.WrongAnswer66,
      WrongAnswer77: this.WrongAnswer77,
      RightAnswer1: this.RightAnswer1,
      WrongAnswer1: this.WrongAnswer1,
      WrongAnswer2: this.WrongAnswer2,
      WrongAnswer3: this.WrongAnswer3,
      WrongAnswer4: this.WrongAnswer4,
      WrongAnswer5: this.WrongAnswer5,
      WrongAnswer6: this.WrongAnswer6,
      WrongAnswer7: this.WrongAnswer7,
    };
    this.EmitpreviewDetails.emit(list1);
  }

  Breadcrumblist: any;
  getBreadcrumbDetails() {
    this.service
      .getBreadcrumbDetails({ ID: this.subjectById.Subject_Id })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          // }).catch((e: any) => {
          //   this.subjectById = null;
          // }
          // )
        },
        (error) => {
          console.log(error);
        }
      );
  }

  Editformvalidation() {
    if (this.AddQuestionform.valid && this.QuestionBodyflag) {
      var Language_Type_Code =
        this.AddQuestionform.controls['Language_Type_Code'].value;
      var Question_Primary_Usage_Type_Code =
        this.AddQuestionform.controls['Question_Primary_Usage_Type_Code'].value;
      var Answer_Selection_Type_Code =
        this.AddQuestionform.controls['Answer_Selection_Type_Code'].value;
      var Answer_Type_Code =
        this.AddQuestionform.controls['Answer_Type_Code'].value;
      var Question_Status_Type_Code =
        this.AddQuestionform.getRawValue().Question_Status_Type_Code;
      var Location_ID = this.AddQuestionform.controls['Location_ID'].value;
      var Question_Gk_Type_Code =
        this.AddQuestionform.getRawValue().Question_Gk_Type_Code;
      var Recommended_Response_Time_Type_Code =
        this.AddQuestionform.controls['Recommended_Response_Time_Type_Code']
          .value;
      var Comment_Text = this.AddQuestionform.controls['Comment_Text'].value;
      var Allow_Translation_Ind = this.translationflag;
      var Multi_Part_Question_Ind = this.Multiquestionflag;

      if (Comment_Text == '') {
        Comment_Text = null;
      }

      if (Language_Type_Code != this.getQuestionByIDlist[0].Language_Type_Code)
        this.tempvariable = true;
      else if (
        Question_Primary_Usage_Type_Code !=
        this.getQuestionByIDlist[0].Question_Primary_Usage_Type_Code
      )
        this.tempvariable = true;
      else if (
        Answer_Selection_Type_Code !=
        this.getQuestionByIDlist[0].Answer_Selection_Type_Code
      )
        this.tempvariable = true;
      else if (Answer_Type_Code != this.getQuestionByIDlist[0].Answer_Type_Code)
        this.tempvariable = true;
      else if (
        Question_Status_Type_Code !=
        this.getQuestionByIDlist[0].Question_Status_Type_Code
      )
        this.tempvariable = true;
      else if (Location_ID != this.getQuestionByIDlist[0].Location_ID)
        this.tempvariable = true;
      else if (
        Question_Gk_Type_Code !=
        this.getQuestionByIDlist[0].Question_Gk_Type_Code
      )
        this.tempvariable = true;
      else if (
        Recommended_Response_Time_Type_Code !=
        this.getQuestionByIDlist[0].Recommended_Response_Time_Type_Code
      )
        this.tempvariable = true;
      else if (Comment_Text != this.getQuestionByIDlist[0].Comment_Text)
        this.tempvariable = true;
      else if (
        Allow_Translation_Ind !=
        (this.getQuestionByIDlist[0].Allow_Translation_Ind == 'Y'
          ? true
          : false)
      )
        this.tempvariable = true;
      else if (
        Multi_Part_Question_Ind !=
        (this.getQuestionByIDlist[0].Multi_Part_Question_Ind == 'Y'
          ? true
          : false)
      )
        this.tempvariable = true;
      else this.tempvariable = false;
    }
  }

  clkQuestionPreview() {
    this.Buttonflg = 'clkQuestionPreview';
    this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    // if(this.RightAnswer1&&this.RightAnswer1!=undefined){
    //   this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    //   }
    //   else if(this.WrongAnswer1&&this.WrongAnswer1!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer1);
    //   }
    //   else if(this.WrongAnswer2&&this.WrongAnswer2!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer2);
    //   }
    //   else if(this.WrongAnswer3&&this.WrongAnswer3!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer3);
    //   }
    //   else if(this.WrongAnswer4&&this.WrongAnswer4!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer4);
    //   }
    //   else if(this.WrongAnswer5&&this.WrongAnswer5!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer5);
    //   }
    //   else if(this.WrongAnswer6&&this.WrongAnswer6!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer6);
    //   }
    //   else if(this.WrongAnswer7&&this.WrongAnswer7!=undefined){
    //     this.EmitAnswerChoiceDetails.emit(this.WrongAnswer7);
    //   }
    //   else{
    //     this.EmitAnswerChoiceDetails.emit(this.RightAnswer1);
    //   }
    if (!this.tempvariable) {
      let list = {
        safehtmlStr: this.safehtmlStr,
        RightAnswer11: this.RightAnswer11,
        WrongAnswer11: this.WrongAnswer11,
        WrongAnswer22: this.WrongAnswer22,
        WrongAnswer33: this.WrongAnswer33,
        WrongAnswer44: this.WrongAnswer44,
        WrongAnswer55: this.WrongAnswer55,
        WrongAnswer66: this.WrongAnswer66,
        WrongAnswer77: this.WrongAnswer77,
        RightAnswer1: this.RightAnswer1,
        WrongAnswer1: this.WrongAnswer1,
        WrongAnswer2: this.WrongAnswer2,
        WrongAnswer3: this.WrongAnswer3,
        WrongAnswer4: this.WrongAnswer4,
        WrongAnswer5: this.WrongAnswer5,
        WrongAnswer6: this.WrongAnswer6,
        WrongAnswer7: this.WrongAnswer7,
      };
      this.ClickQuestionPreview.emit(list);
    } else {
      this.Alertpopup();
    }
  }

  ClkReviewQuestion(data: any) {
    let list = {
      Question_status: data,
      Question: this.getQuestionByIDlist[0],
    };
    this.ClickQuestionstatus.emit(list);
  }
  StatusHistory() {
    this.ClickQuestionStatusPopup.emit(this.getQuestionByIDlist[0]);
  }

  Answerdetails: any;
  DeleteAnswerChoice(data: any) {
    this.Answerdetails = data;
    this.DeleteAnswerchoicepopup();
  }

  deletealertpopup: boolean;
  DeleteAnswerchoicepopup() {
    this.deletealertpopup = !this.deletealertpopup;
  }

  replacedeletebutton() {
    this.SaveAnswerChoice();
  }

  CloseDeleteAlertpopup() {
    this.DeleteAnswerchoicepopup();
  }

  AddAnswerChoiceResponse: any;
  index: Number;
  test: string;
  modalclose: any;
  SaveAnswerChoice() {
    this.InsertAnswerChoice = this.AddQuestionform.getRawValue();
    this.InsertAnswerChoice.QuestionID = this.Answerdetails.Question_ID;
    this.InsertAnswerChoice.Question_Status_ID =
      this.Answerdetails.Question_Status_ID;
    this.InsertAnswerChoice.AnswerChoiceID =
      this.Answerdetails.Answer_Choice_ID;

    this.service.DeleteAnswerChoice(this.InsertAnswerChoice).subscribe(
      (i: any) => {
        this.AddAnswerChoiceResponse = i;
        if (this.AddAnswerChoiceResponse.Message == 'Success') {
          this.toastr.success('Answer Choice Deleted Successfully');
          this.RightAnswer1 = null;
          this.WrongAnswer1 = null;
          this.WrongAnswer2 = null;
          this.WrongAnswer3 = null;
          this.WrongAnswer4 = null;
          this.WrongAnswer5 = null;
          this.WrongAnswer6 = null;
          this.WrongAnswer7 = null;
          this.RightAnswer11 = this.test;
          this.WrongAnswer11 = this.test;
          this.WrongAnswer22 = this.test;
          this.WrongAnswer33 = this.test;
          this.WrongAnswer44 = this.test;
          this.WrongAnswer55 = this.test;
          this.WrongAnswer66 = this.test;
          this.WrongAnswer77 = this.test;
          this.DeleteAnswerchoicepopup();
          this.ngOnInit();
        } else {
          this.toastr.error(this.AddAnswerChoiceResponse.Message);
        }
      },
      (error) => {
        this.AddAnswerChoiceResponse = error;
        this.toastr.error(this.AddAnswerChoiceResponse.statusText);
        this.save_submitted = false;
        console.log(error);
      }
    );
  }

  relocatepopupflag: boolean;
  relocatepopup() {
    this.Buttonflg = 'relocatepopup';
    if (!this.tempvariable) {
      this.relocatepopupflag = !this.relocatepopupflag;
    } else {
      this.Alertpopup();
    }
  }
  CloseRelocateQuestion(_data: any) {
    if (this.relocatepopupflag) {
      this.relocatepopup();
    }
  }

  QuestionUsagepopupflag: boolean;
  QuestionUsage() {
    this.Buttonflg = 'QuestionUsage';
    if (!this.tempvariable) {
      this.QuestionUsagepopupflag = !this.QuestionUsagepopupflag;
      this.QuestionNo = this.selectedQuestionById[0].Question_ID;
      this.SubjectID = this.subjectById.Subject_Id;
      if (this.QuestionNo && this.SubjectID) {
        this.getQuestionUsage({
          QuestionID: this.QuestionNo,
          SubjectID: this.SubjectID,
        });
      }
    } else {
      this.Alertpopup();
    }
  }

  closequestionusage(_value: any) {
    this.CloseQuestionUsage();
  }

  CloseQuestionUsage() {
    if (this.QuestionUsagepopupflag) {
      this.QuestionUsage();
    }
  }
  clickquestionusage() {
    this.QuestionUsage();
  }

  Previousflag: boolean = false;
  Nextflag: boolean = false;
  Validation(data: any, index: any) {
    if (data.length <= 1) {
      this.Previousflag = true;
      this.Nextflag = true;
    } else if (index == data.length - 1) {
      this.Previousflag = false;
      this.Nextflag = true;
    } else if (index == data.length - 1) {
      this.Previousflag = true;
      this.Nextflag = false;
    } else if (index == 0) {
      this.Previousflag = true;
      this.Nextflag = false;
    } else {
      this.Previousflag = false;
      this.Nextflag = false;
    }
  }

  PreviousflagButton() {
    this.Buttonflg = 'PreviousflagButton';
    if (!this.tempvariable) {
      this.arrayIndex = this.arrayIndex - 1;
      this.getQuestionByID(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.GetAnswerChoiceByQuestionID(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.Validation(this.questionsubjectresponse, this.arrayIndex);
      this.Refreshlist.emit(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.QuestionNo =
        this.questionsubjectresponse[this.arrayIndex].Question_Id;
      this.SubjectID = this.subjectById.Subject_Id;
      if (this.QuestionNo && this.SubjectID) {
        this.getQuestionUsage({
          QuestionID: this.QuestionNo,
          SubjectID: this.SubjectID,
        });
      }
      this.Clear();
    } else {
      this.Alertpopup();
    }
  }

  NextButton() {
    this.Buttonflg = 'NextButton';
    if (!this.tempvariable) {
      this.arrayIndex = this.arrayIndex + 1;
      this.getQuestionByID(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.GetAnswerChoiceByQuestionID(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.Validation(this.questionsubjectresponse, this.arrayIndex);
      this.Refreshlist.emit(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.QuestionNo =
        this.questionsubjectresponse[this.arrayIndex].Question_Id;
      this.SubjectID = this.subjectById.Subject_Id;
      if (this.QuestionNo && this.SubjectID) {
        this.getQuestionUsage({
          QuestionID: this.QuestionNo,
          SubjectID: this.SubjectID,
        });
      }
      this.Clear();
    } else {
      this.Alertpopup();
    }
  }

  Clear() {
    this.RightAnswer1 = null;
    this.WrongAnswer1 = null;
    this.WrongAnswer2 = null;
    this.WrongAnswer3 = null;
    this.WrongAnswer4 = null;
    this.WrongAnswer5 = null;
    this.WrongAnswer6 = null;
    this.WrongAnswer7 = null;
    this.RightAnswer11 = this.test;
    this.WrongAnswer11 = this.test;
    this.WrongAnswer22 = this.test;
    this.WrongAnswer33 = this.test;
    this.WrongAnswer44 = this.test;
    this.WrongAnswer55 = this.test;
    this.WrongAnswer66 = this.test;
    this.WrongAnswer77 = this.test;
    this.getQuestionUsagelist = null;
    this.safehtmlStr = this.test;
    this.InitializeForm();
  }
  validate1: boolean;
  alertpopupflag: boolean;
  Alertpopup() {
    this.alertpopupflag = !this.alertpopupflag;
  }

  Savecontent() {
    if (this.alertpopupflag) {
      this.Alertpopup();
    }
    //this.validate1=false;
    this.AddQuestionHeader();
  }

  alertclose() {
    if (this.alertpopupflag) {
      this.Alertpopup();
    }
    this.tempvariable = false;
    if (
      this.selectedQuestionById != null &&
      this.selectedQuestionById != undefined
    ) {
      if (this.selectedQuestionById.length >= 0) {
        if (this.selectedQuestionById[0].Question_ID != null) {
          this.getQuestionByID(this.selectedQuestionById[0].Question_ID);
        }
      }
    }

    if (this.Buttonflg == 'NextButton') {
      this.arrayIndex = this.arrayIndex + 1;
      this.getQuestionByID(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.GetAnswerChoiceByQuestionID(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.Validation(this.questionsubjectresponse, this.arrayIndex);
      this.Refreshlist.emit(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.QuestionNo =
        this.questionsubjectresponse[this.arrayIndex].Question_Id;
      this.SubjectID = this.subjectById.Subject_Id;
      if (this.QuestionNo && this.SubjectID) {
        this.getQuestionUsage({
          QuestionID: this.QuestionNo,
          SubjectID: this.SubjectID,
        });
      }
      this.Clear();
    }
    if (this.Buttonflg == 'PreviousflagButton') {
      this.arrayIndex = this.arrayIndex - 1;
      this.getQuestionByID(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.GetAnswerChoiceByQuestionID(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.Validation(this.questionsubjectresponse, this.arrayIndex);
      this.Refreshlist.emit(
        this.questionsubjectresponse[this.arrayIndex].Question_Id
      );
      this.QuestionNo =
        this.questionsubjectresponse[this.arrayIndex].Question_Id;
      this.SubjectID = this.subjectById.Subject_Id;
      if (this.QuestionNo && this.SubjectID) {
        this.getQuestionUsage({
          QuestionID: this.QuestionNo,
          SubjectID: this.SubjectID,
        });
      }
      this.Clear();
    }
    if (this.Buttonflg == 'QuestionUsage') {
      this.QuestionUsagepopupflag = !this.QuestionUsagepopupflag;
      this.QuestionNo = this.selectedQuestionById[0].Question_ID;
      this.SubjectID = this.subjectById.Subject_Id;
      if (this.QuestionNo && this.SubjectID) {
        this.getQuestionUsage({
          QuestionID: this.QuestionNo,
          SubjectID: this.SubjectID,
        });
      }
    }

    if (this.Buttonflg == 'relocatepopup') {
      this.relocatepopupflag = !this.relocatepopupflag;
    }
    if (this.Buttonflg == 'clkQuestionPreview') {
      let list = {
        safehtmlStr: this.safehtmlStr,
        RightAnswer11: this.RightAnswer11,
        WrongAnswer11: this.WrongAnswer11,
        WrongAnswer22: this.WrongAnswer22,
        WrongAnswer33: this.WrongAnswer33,
        WrongAnswer44: this.WrongAnswer44,
        WrongAnswer55: this.WrongAnswer55,
        WrongAnswer66: this.WrongAnswer66,
        WrongAnswer77: this.WrongAnswer77,
        RightAnswer1: this.RightAnswer1,
        WrongAnswer1: this.WrongAnswer1,
        WrongAnswer2: this.WrongAnswer2,
        WrongAnswer3: this.WrongAnswer3,
        WrongAnswer4: this.WrongAnswer4,
        WrongAnswer5: this.WrongAnswer5,
        WrongAnswer6: this.WrongAnswer6,
        WrongAnswer7: this.WrongAnswer7,
      };
      this.ClickQuestionPreview.emit(list);
    }
  }
}
